module.exports = __webpack_public_path__ + "img/20210806_103844.3a3e41e1.jpg";